import logo from "../assets/imagenes/logo_medical.png";
import { Link } from 'react-router-dom';

const Header = () => {
  return (
    <nav className="navbar navbar-expand-lg bg-white">
        <div className="container px-4">
            <Link to="/">
                  <img
                    src={logo}
                    alt="MEDICAL ASSISTANT"
                    style={{
                      height: 'auto',
                      maxHeight: '70px',
                      width: 'auto'
                    }}
                    className="navbar-brand"
                  />
            </Link>
            <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
              <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse" id="navbarNavDropdown">
              <ul className="navbar-nav ms-auto">
                <li className="nav-item px-2"> 
                  <Link className="nav-link" to="/">Inicio</Link>
                </li>
                <li className="nav-item px-2">
                  <Link className="nav-link" to="/servicios">Servicios</Link>
                </li>
                <li className="nav-item px-2">
                  <Link className="nav-link" to="/nosotros">Nosotros</Link>
                </li>
                <li className="nav-item px-2">
                  <Link className="nav-link" to="/contacto">Contacto</Link>
                </li>
              </ul>
            </div>
        </div>
    </nav>
  )
}
export default Header;